import axios from "axios";
import { DASHBOARD, ADMINDASHBOARD, REGIONALADMINDASHBOARD, SAVE_REMINDER_CONFIG, COUNTRYMODULETYPEDASHBOARD } from '../../constants/api';
import { ShowException, ShowSuccessOrError } from '../utils/tostar';
import { MESSAGE_FOR_SAVED, REMINDER } from 'src/constants/NotificationMessageConstant';

export const getDashboardData = (countryData: any) => {
    return axios.get(DASHBOARD + "?countryId=" + countryData.countryId + "&surveyId=" + countryData.surveyId)
        .then((resp: any) => {
            return resp;
        }, (err: any) => {
            ShowException(err);
            return err;
        })
}

export const getAdminDashboardData = (data: any) => {
    return axios.get(ADMINDASHBOARD + "?surveyId=" + data.surveyId)
        .then((resp: any) => {
            return resp;
        }, (err: any) => {
            ShowException(err);
            return err;
        })
}

export const getRegionalAdminDashboardData = (data: any) => {
    return axios.get(REGIONALADMINDASHBOARD + "?surveyId=" + data.surveyId)
        .then((resp: any) => {
            return resp;
        }, (err: any) => {
            ShowException(err);
            return err;
        })
}

export const saveReminderConfigCall = (data: any) => {
    return axios.post(SAVE_REMINDER_CONFIG, data.payload)
        .then((resp: any) => {
            ShowSuccessOrError(REMINDER + MESSAGE_FOR_SAVED, resp);
            return resp;
        }, (err: any) => {
            ShowException(err);
            return err;
        })
}

export const getCountyModuleTypeDashboardCall = (data: any) => {
    return axios.get(COUNTRYMODULETYPEDASHBOARD + "?countryId=" + data.countryId + "&moduleTypeId=" + data.moduleTypeId + "&surveyId=" + data.surveyId)
        .then((resp: any) => {
            return resp;
        }, (err: any) => {
            ShowException(err);
            return err;
        })
}



// WEBPACK FOOTER //
// ./src/effects/api/api.userDashboard.tsx